import { render, staticRenderFns } from "./MandateTransactionsDetailsUnit.vue?vue&type=template&id=c36f15b6&scoped=true&"
import script from "./MandateTransactionsDetailsUnit.vue?vue&type=script&lang=js&"
export * from "./MandateTransactionsDetailsUnit.vue?vue&type=script&lang=js&"
import style0 from "./MandateTransactionsDetailsUnit.vue?vue&type=style&index=0&id=c36f15b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36f15b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c36f15b6')) {
      api.createRecord('c36f15b6', component.options)
    } else {
      api.reload('c36f15b6', component.options)
    }
    module.hot.accept("./MandateTransactionsDetailsUnit.vue?vue&type=template&id=c36f15b6&scoped=true&", function () {
      api.rerender('c36f15b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Manda/MandateTransactionsDetailsUnit.vue"
export default component.exports